import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BufferGeometry } from './BufferGeometry.js';

var InstancedBufferGeometry = /*#__PURE__*/function (_BufferGeometry) {
  _inherits(InstancedBufferGeometry, _BufferGeometry);

  var _super = _createSuper(InstancedBufferGeometry);

  function InstancedBufferGeometry() {
    var _this;

    _classCallCheck(this, InstancedBufferGeometry);

    _this = _super.call(this);
    _this.type = 'InstancedBufferGeometry';
    _this.instanceCount = Infinity;
    return _this;
  }

  _createClass(InstancedBufferGeometry, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(InstancedBufferGeometry.prototype), "copy", this).call(this, source);

      this.instanceCount = source.instanceCount;
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(InstancedBufferGeometry.prototype), "toJSON", this).call(this, this);

      data.instanceCount = this.instanceCount;
      data.isInstancedBufferGeometry = true;
      return data;
    }
  }]);

  return InstancedBufferGeometry;
}(BufferGeometry);

InstancedBufferGeometry.prototype.isInstancedBufferGeometry = true;
export { InstancedBufferGeometry };